import './index.css'

import { Theme } from '@radix-ui/themes'
import lodashGet from 'lodash/get'
import React from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import type { Recipient } from 'types/list'
import type { Location } from 'react-router-dom'
import type { Track } from 'types/track'

import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'

import { Flex } from 'components/ds'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import modalStyles from 'components/utils/modalStyles'

class SendTrackConfirmation extends React.Component<{
  onClose: (...args) => any
  sendMixpanelEvent: typeof sendMixpanelEvent
  onShareAgain: (...args) => any
  recipients: Recipient[]
  track?: Track
  location: Location
}> {
  _statsUrl() {
    if (!this.props.track) return ''
    const trackId = this.props.track.id
    const returnPath = lodashGet(this.props, 'location.pathname', '/')
    return `/explorer/tracks/${trackId}/stats?return=${returnPath}`
  }

  _renderSuccessMessage() {
    const accessStatisticsLink = (
      <Link className="SendTrackConfirmation_Link" to={this._statsUrl()}>
        access statistics here
      </Link>
    )

    return (
      <div className="SendTrackConfirmation_Text">
        Your recipients will receive an email shortly! You can check{' '}
        {accessStatisticsLink}.
      </div>
    )
  }

  render() {
    return (
      <Modal onRequestClose={this.props.onClose} isOpen style={modalStyles}>
        <Theme>
          <div className="TrackSendConfirmationForm">
            <h1 className="Form_Header is-centred">Track Sent!</h1>
            {this._renderSuccessMessage()}
            <Flex direction="column" align="center" mt="4">
              <ButtonContainer centered>
                <Button
                  appearance="primary"
                  caption="Share again"
                  onClick={this.props.onShareAgain}
                />
                <Button caption="Close" onClick={this.props.onClose} />
              </ButtonContainer>
            </Flex>
          </div>
        </Theme>
      </Modal>
    )
  }
}

export default connect(null, { sendMixpanelEvent })(SendTrackConfirmation)
